export default function () {
  if (document.getElementById('invoice-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "invoice-vue-app" */ '../_03_organisms/invoice/main');
  }
}
